import axios from 'axios';
import { isWebView, getWebviewAccessToken } from './webviewService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://ai-agent-api.basalam.com';


function resolveToken(): string | undefined {
  if (typeof window === "undefined") return undefined;

  return isWebView()
    ? getWebviewAccessToken()
    : localStorage.getItem("authToken") ?? undefined;
}
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = resolveToken();

    if (token) {
      config.headers?.set("Authorization", `Bearer ${token}`);
    }

    return config;
  },
  (error) => Promise.reject(error)
);
// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('authToken');
      // Don't redirect for user info endpoint
      if (!error.config.url?.includes('/user/info')) {
        // For other endpoints, let the auth context handle the UI
        // by rejecting the promise which will trigger re-authentication check
      }
    }
    return Promise.reject(error);
  }
);

export default api;
